/* eslint-disable react/jsx-indent */
import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';
import { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

const useQuery = (url, search, initialQuery = null) => {
    const history = useHistory();

    const query = useMemo(
        () =>
            parseQuery(search, {
                arrayFormat: 'bracket',
            }),
        [search],
    );

    const [internalQuery, setInternalQuery] = useState(query);

    const setQuery = useCallback(
        (newQuery = {}, page = null, count = null) => {
            const {
                page: pageNumber,
                count: pageCount,
                ...queryWithoutPageAndCount
            } = newQuery || {};

            const queryString = stringifyQuery(
                page !== null
                    ? { ...queryWithoutPageAndCount, page, count }
                    : queryWithoutPageAndCount,
                {
                    arrayFormat: 'bracket',
                },
            );
            history.push(`${url}?${queryString}`);
            setInternalQuery(newQuery);
        },
        [history, url, query, initialQuery, setInternalQuery],
    );

    const resetQuery = useCallback(() => {
        history.push(url);
    }, [history, url]);

    return {
        setQuery,
        resetQuery,
        query: internalQuery,
    };
};

export default useQuery;
